export default function(json) {
  let obj = JSON.parse(JSON.stringify(json));
  obj.records = obj.list;
  delete obj.list;
  return obj;
}
